import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label, bindMethods } from '../index';
import './Field.scss';

export default class Field extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      labelOn: !!props.value,
    };
    bindMethods(this, ['onFocus', 'onBlur']);
  }

  onFocus() {
    this.setState({
      focus: true,
      labelOn: true,
    });
  }

  onBlur(value) {
    this.setState({
      focus: false,
      labelOn: !!value,
    });
  }

  render() {
    const { onFocus, onBlur, state } = this;
    const { style, label, children, className, error } = this.props;
    const { focus, labelOn } = state;
    return (
      <div className={`form-field ${className} ${labelOn ? 'focus' : ''}`} style={style}>
        <Label type="form" onClick={onFocus}>{label}</Label>
        {children(onFocus, onBlur, focus)}
        {error && <div className="error">{error || '\u00A0'}</div>}
      </div>
    );
  }
}

Field.propTypes = {
  style: PropTypes.shape(),
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  value: PropTypes.node,
  error: PropTypes.node,
};

Field.defaultProps = {
  style: {},
  className: '',
  value: '',
  error: null,
};
